export default function Video() {
	// Set the videos within the DOM by selecting elements with the class 'js-video'
	const videos = document.querySelectorAll('.js-video');

	// Check if there are any videos on the page
	if (videos.length) {
		// Loop over all the video elements
		videos.forEach(function(item) {
			// Create an object for the current video element
			const video = {
				element: item,
				videoElement: item.querySelector('.js-video-source') // Find the video source element within the current video
			}

			// Return if no video source element was found
			if (!video.videoElement) return;

			// Set the src attribute of the video from the 'data-src' attribute of the video source element
			video.src = video.videoElement.dataset.src;

			// Add a click event listener to the video element
			video.element.addEventListener('click', function(e) {
				// Prevent the default behavior of the click event
				e.preventDefault();

				// Add the 'isActive' class to the video source element, potentially to trigger some styling
				video.videoElement.classList.add('isActive');

				// Set the src attribute of the video source element to the previously set src
				video.videoElement.src = video.src;
			});
		});
	}
}
